<template>
  <div class="journal-page">
    <h1 class="section-title" style="text-align: center; margin-top: 30px">
      Dziennik praktyk
    </h1>
    <div class="journal-privacy">
      <EyeOffIcon />
      Widoczny tylko dla Ciebie
    </div>

    <div class="journal-card">
      <div class="journal-header">
        <div class="filter-group">
          <button
            class="chip"
            :class="{ active: filterType === 'ALL' }"
            @click="changeFilter('ALL')"
          >
            Wszystkie
          </button>
          <button
            class="chip"
            :class="{ active: filterType === 'GENERAL' }"
            @click="changeFilter('GENERAL')"
          >
            Platforma jogi online - Ogólna
          </button>
          <button
            class="chip"
            :class="{ active: filterType === 'FOR_BEGINNERS' }"
            @click="changeFilter('FOR_BEGINNERS')"
          >
            Platforma jogi online - Początek
          </button>
        </div>
      </div>

      <div v-if="loading" class="journal-info">Ładowanie notatek...</div>
      <div v-else-if="!filteredNotes.length" class="journal-info">
        Brak notatek
      </div>
      <div v-else class="notes-list">
        <div v-for="note in filteredNotes" :key="note.id" class="note-row">
          <PracticeNote
            :timePackageItemId="note.timePackageItemId"
            :initialNote="note"
            :noteTitle="
              note.timePackageItem && note.timePackageItem.name
                ? note.timePackageItem.name
                : 'Praktyka'
            "
            :allowDelete="true"
            :showJournalLink="false"
            :titleClickable="true"
            :forBeginners="note.type === 'FOR_BEGINNERS'"
            @title-click="goToVideo(note)"
            @deleted="refreshNotes"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PracticeNote from "../components/PracticeNote.vue";
import EyeOffIcon from "../components/icons/EyeOffIcon.vue";

export default {
  name: "PracticeJournal",
  components: { PracticeNote, EyeOffIcon },
  data() {
    return {
      loading: false,
      filterType: "ALL",
    };
  },
  computed: {
    notes() {
      return this.$store.getters["notes/getAllNotes"];
    },
    filteredNotes() {
      if (this.filterType === "ALL") return this.notes;
      return this.notes.filter((note) => note.type === this.filterType);
    },
  },
  async created() {
    const token = this.$store.getters["auth/getToken"];
    if (!token) {
      this.$router.push({ name: "Auth" });
      return;
    }
    this.loading = true;
    await this.$store.dispatch("notes/fetchAllNotes");
    this.loading = false;
  },
  methods: {
    changeFilter(type) {
      this.filterType = type;
    },
    async refreshNotes() {
      await this.$store.dispatch("notes/fetchAllNotes");
    },
    goToVideo(note) {
      const item = note.timePackageItem || note.time_package_item;
      const name = item && item.name ? item.name : "praktyka";
      this.$router.push({
        name: "Videos",
        query: {
          id: `${name.replaceAll(" ", "-")}_${note.timePackageItemId}`,
        },
      });
    },
  },
};
</script>

<style scoped>
.journal-page {
  max-width: 1200px;
  margin: 0 auto 40px;
}
.journal-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-top: 20px;
}
@media (min-width: 960px) {
  .journal-grid {
    grid-template-columns: 1fr;
  }
}
.journal-card {
  background: #d9d9d9;
  border-radius: 32px;
  padding: 40px;
  box-shadow: 0 0 100px 25px #b6afa5;
  margin-top: 40px;
}
.journal-card__title {
  color: #54514c;
  font-weight: 700;
  margin-bottom: 8px;
}
.journal-card__hint {
  color: #8b857d;
  font-size: 14px;
  margin-bottom: 12px;
}
.journal-card__actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.journal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.filter-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.chip {
  border: none;
  border-radius: 16px;
  padding: 10px 20px;
  background: #c5c0b9;
  color: #54514c;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.3s;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-transform: none;
}
.chip:hover {
  background: #e5e5e5;
}
.chip.active {
  background: #8b857d;
  color: #ffffff;
}
.chip.active:hover {
  background: #9e948c;
}
.journal-info {
  color: #54514c;
  font-size: 14px;
  margin-top: 10px;
}
.notes-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 14px;
}
.note-row {
  /* border: 1px solid #ece9e3; */
  border-radius: 10px;
  padding: 14px;
  padding-bottom: 30px;
  /* background: #faf8f4; */
}
.note-row :deep(.note-card__actions) {
  padding-top: 6px;
}
.note-row :deep(.note-card) {
  box-shadow: none;
  border: none;
  padding: 0;
  margin-top: 0;
  background: transparent;
}
.note-row :deep(.note-card__header) {
  margin-bottom: 6px;
}
.note-row :deep(.note-card__practice) {
  margin-bottom: 6px;
}
.journal-privacy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 16px;
  color: #54514c;
  font-weight: 500;
}
</style>
